



















import { InstantDropdownElInterface } from '@/config/interfaces'
import Vue from 'vue'

export default Vue.extend({
  name: 'InstantDropdownEl',

  props: {
    templateItemData: {
      type: Object as () => InstantDropdownElInterface,
      required: true
    }
  },

  data: () => ({
    selected: ''
  }),

  mounted () {
    this.selected = this.templateItemData.value
  },

  destroyed () {
    this.$store.dispatch('postParams', null)
  },

  methods: {
    onChangeAction () {
      this.getView(this.$props.templateItemData.view ?? 'card', this.$props.templateItemData.uri, this.getInputRefs())
    },

    getInputRefs: function (): URLSearchParams {
      return new URLSearchParams({ dns_report_day_range: this.selected.toString() })
    }
  }
})
